// Module
var code = "<fieldset> <div class=\"col-xs-12\"> <h5><b>Work Orders</b></h5> <div ng-repeat=\"element in model[options.key]\" ng-init=\"localFields = createLocalFields(to.fields)\" ng-class=\"{'row-odd-repeater': $odd}\" style=\"height:78px\" class=\"formly control-row\"> <formly-form model=\"element\" fields=\"localFields\" form=\"form\"> </formly-form> </div> </div> </fieldset>";
// Exports
var _module_exports = code;;
var path = 'work-orders/Pages/Assign/index.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;